/// <amd-module name="VSS/Redux/Modules/Shortcuts/ShortcutsContracts" />
import { IShortcut, IShortcutGroup } from "VSS/Platform/KeyboardShortcuts";
import { AnyAction } from "redux";

// Using Pick and Exclude because action is required on IShortcut and is type KeyboardAction. We want to
// use a redux action instead.
export interface IReduxShortcut extends Pick<IShortcut, Exclude<keyof IShortcut, "action">> {
    /** Action to dispatch when the keyboard shortcut is pressed */
    action: AnyAction;
}

export interface IReduxShortcutGroup extends Pick<IShortcutGroup, Exclude<keyof IShortcutGroup, "shortcuts">> {
    shortcuts: IReduxShortcut[];
}
